import React from 'react'
import './CrumbButton.scss'

export const CrumbButton = () => <div className="crumb-btn"><span>...</span></div>
